import { render, staticRenderFns } from "./SbolDetailInitialPage.vue?vue&type=template&id=4640660b&scoped=true&"
import script from "./SbolDetailInitialPage.vue?vue&type=script&lang=js&"
export * from "./SbolDetailInitialPage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolDetailInitialPage.vue?vue&type=style&index=0&id=4640660b&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4640660b",
  null
  ,true
)

export default component.exports